module.exports = {
	"header": "Terminology",
	"terms": {
		"absenteebidder": {
			"term": "Absentee Bidder",
			"definition": "A person who does not attend the auction but submits, in advance, a bid that indicates the maximum price he or she is willing to pay for a lot."
		},
		"appraisal": {
			"term": "Appraisal",
			"definition": "The act or process of estimating value."
		},
		"asIs": {
			"term": "As Is",
			"definition": "Selling the lot without warranties as to the condition and/or the fitness of the lot for a particular use. Buyers are solely responsible for examining and judging the lot for their own protection. Otherwise known as “As Is”, “Where Is” and “In its Present Condition”."
		},
		"auction": {
			"term": "Auction",
			"definition": "A method of selling lots in a public forum through open and competitive bidding. Also known as “public auction“ or “auction sale.”"
		},
		"auctionBlock": {
			"term": "Auction Block",
			"definition": "The podium or raised platform where the auctioneer stands while conducting the auction."
		},
		"auctionPrice": {
			"term": "Auction Price",
			"definition": "The price of a lot obtained through the auction method."
		},
		"auctionSubjectToConfirmation": {
			"term": "Auction Subject to Confirmation",
			"definition": "(See “Reserve Price”)"
		},
		"auctionValue": {
			"term": "Auction Value",
			"definition": "The price that a particular lot brings via competitive bidding at public auction."
		},
		"auctionWithReserve": {
			"term": "Auction With Reserve",
			"definition": "An auction in which the seller or his agent reserves the right to accept or decline any and all bids. A minimum acceptable price may or may not be disclosed and the seller reserves the right to accept or decline any bid."
		},
		"auctioneer": {
			"term": "Auctioneer",
			"definition": "The person whom the seller engages to direct, conduct, or be responsible for a sale by auction. This person may or may not actually call or “shout” the auction."
		},
		"bankLetterOfCredit": {
			"term": "Bank Letter of Credit",
			"definition": "A letter from a bank certifying that a named person is worthy of a given level of credit. Often requested from prospective bidders or buyers who are not paying with currency at auctions."
		},
		"bid": {
			"term": "$t(auction::lot.bid)",
			"definition": "A prospective buyer's indication or offer of a price they are willing to pay to purchase lots at auction. Bids are usually in standardized increments established by the auctioneer."
		},
		"buyerPremium": {
			"term": "$t(organization::buyerPremium)",
			"definition": "An advertised percentage of the high bid or flat fee added to the high bid."
		},
		"catalog": {
			"term": "Catalog",
			"definition": "A publication advertising and describing the lots available for sale at the auction, often including photographs, descriptions and the terms and conditions of the sale."
		},
		"collusion": {
			"term": "Collusion",
			"definition": "The unlawful practice whereby two or more people agree not to bid against one another so as to deflate value or when the auctioneer accepts a fictitious bid on behalf of the seller so as to manipulate or inflate the price of the lot."
		},
		"conditionsOfSale": {
			"term": "Conditions of Sale",
			"definition": "The legal terms that govern the conduct of an auction, including acceptable methods of payment, terms, buyer's premiums, possession, reserves and any other limiting factors of an auction. Usually included in published advertisements or announced by the auctioneer prior to the start of the auction. Also known as “Terms & Conditions”."
		},
		"dueDiligence": {
			"term": "Due Diligence",
			"definition": "The process of gathering information about the condition and legal status of assets to be sold."
		},
		"hammerPrice": {
			"term": "Hammer Price",
			"definition": "Price established by the last bidder and acknowledged by the auctioneer before dropping the hammer."
		},
		"listingAgreement": {
			"term": "Listing Agreement",
			"definition": "A contract executed by the auctioneer and the seller which authorizes the auctioneer to conduct the auction and sets out the terms of the agreement and the rights and responsibilities of each party."
		},
		"liveAuction": {
			"term": "Live Auction",
			"definition": "Allows buyers to place bids at the same time the auction is taking place on the premises of the event. Bidders can place bids using their computer or mobile device."
		},
		"lot": {
			"term": "Lot",
			"definition": "The item(s) being sold in an auction. Sometimes a group of items is sold as one single lot. Lots are normally denoted by a unique lot number."
		},
		"marketValue": {
			"term": "Market Value",
			"definition": "The price an asset would fetch in the marketplace."
		},
		"minimumBidAuction": {
			"term": "Minimum Bid Auction",
			"definition": "An auction in which the auctioneer will accept bids at or above a specific price, disclosed or not."
		},
		"onLineAuction": {
			"term": "Online Auction",
			"definition": "An auction that occurs only on the web and not conducted in front of a live audience."
		},
		"onSiteAuction": {
			"term": "On-Site Auction",
			"definition": "An auction conducted on the premises of the lots being sold."
		},
		"openingBid": {
			"term": "Opening Bid",
			"definition": "The first bid offered by a bidder at an auction."
		},
		"preview": {
			"term": "Preview",
			"definition": "Specified date and time property is available for prospective buyer viewing and audits. Also known as “Open House” or “Inspection”."
		},
		"reserve": {
			"term": "Reserve Price",
			"definition": "The minimum price that a seller is willing to accept for a property to be sold at auction. Also known as “reserve”."
		},
		"seller": {
			"term": "Seller",
			"definition": "Entity that has legal possession (ownership) of any interests, benefits or rights inherent to the real or personal property."
		},
		"subjectToConfirmation": {
			"term": "Subject to Confirmation",
			"definition": "The Hammer Price will need to get approved or refused by the seller."
		},
		"termsAndConditions": {
			"term": "Terms and Conditions",
			"definition": "The rules of the auction and certain aspects of the Purchase & Sale Agreement that are read and/or provided to potential bidders prior to an auction sale."
		},
		"tieBids": {
			"term": "Tie Bids",
			"definition": "When two or more bidders bid exactly the same amount at the same time. This must be resolved by the auctioneer."
		},
		"withdraw": {
			"term": "Withdraw",
			"definition": "Failure to reach the reserve price or insufficient bidding."
		}
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/en/terminology.json5
// module id = 1960
// module chunks = 6